<template>
  <div class="sirui-upload">
    <!--上传excel-->
    <el-dialog
      :title="$t('import.importTitle')"
      :visible.sync="dialogUpload"
      :close-on-click-modal="false"
      append-to-body
      width="450px"
    >
      <el-upload
        class="upload-demo"
        ref="upload"
        :action="importUrl"
        :data="data"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :on-error="handleUploadError"
        :file-list="fileList"
        :auto-upload="false"
        :multiple="false"
        :limit="1"
      >
        <el-button slot="trigger" size="small">{{ this.$t('import.chooseFile') }}</el-button>
        <el-button
          style="margin-left: 10px"
          size="small"
          type="primary"
          :loading="loading"
          @click="submitUpload"
          >{{ this.$t('import.submitImport') }}</el-button
        >
        <el-button type="primary" @click="downExcelTemplate(fileKey)">下载模板</el-button>
        <el-button type="primary" @click="viewHistory()">历史查看</el-button>
        <div slot="tip" class="el-upload__tip">{{ this.$t('import.importTips') }}</div>
      </el-upload>
    </el-dialog>
    <ViewHistory ref="viewHistoryRef"></ViewHistory>
  </div>
</template>
<script>
  import baseUrl from '@/common/config';
  import ViewHistory from './ViewHistory.vue';
  export default {
    name: 'exemptionSettingDialog',
    data() {
      return {
        dialogUpload: false,
        fileList: [],
        loading: false,
        fileKey: '',
      };
    },
    props: {
      source: {
        type: String,
        default: () => '',
      },
      //请求地址
      action: {
        type: String,
        default: () => '',
      },
      //额外参数
      data: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      importUrl() {
        return baseUrl + this.action;
      },
    },
    mounted() {},
    methods: {
      viewHistory() {
        this.$refs.viewHistoryRef.openModal();
      },
      openDialog(flag, fileKey = '') {
        this.dialogUpload = flag;
        this.fileKey = fileKey;
        this.fileList = [];
      },
      beforeUpload(file) {
        console.log(file);
        this.loading = true;
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        const extension = testmsg === 'xls';
        const extension2 = testmsg === 'xlsx';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!extension && !extension2) {
          this.loading = false;
          this.$message({
            message: this.$t('import.importType'),
            type: 'error',
          });
        }
        if (!isLt2M) {
          this.loading = false;
          this.$message({
            message: this.$t('import.importLimit'),
            type: 'error',
          });
        }
        return extension || (extension2 && isLt2M);
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed() {
        this.$message({
          message: this.$t('upload.error'),
          type: 'error',
        });
      },
      // handleSuccess(res, file, fileList) {
      //   if (0 == res.code) {
      //     this.dialogUpload = false;
      //     this.$message({
      //       message: this.$t("import.importSuccess"),
      //       type: "success"
      //     });
      //     //刷新列表
      //     this.$emit("getData");
      //   } else {
      //     this.$alert(res.msg);
      //   }
      // },
      handleSuccess(res, file, fileList) {
        this.loading = false;
        if (0 == res.code) {
          this.dialogUpload = false;
          if (res.msg && res.data) {
            this.$message.success('操作成功');
            window.location.href = `${res.data}`;
          } else {
            this.$message({
              message: this.$t('import.importSuccess'),
              type: 'success',
            });
            //返回成功回调
            if (this.$listeners['ossSuccess']) this.$emit('ossSuccess', res, file, fileList);
          }
          //刷新列表
          if (!this.$listeners['ossSuccess']) this.$emit('getData');
        } else {
          this.$message({
            message: res.msg || '操作失败',
            type: 'error',
          });
          if (res.data) {
            window.location.href = `${res.data}`;
          }
        }

        this.fileList = [];
      },
      handleUploadError() {
        this.loading = false;
        console.log('文件上传失败');
      },
    },
    components: { ViewHistory },
  };
</script>
<style lang="scss" scoped>
  $maintheme: #6299fe;
  .upload-demo {
    height: 150px;
  }
  .el-button {
    border: 1px solid $maintheme;
    color: $maintheme;
  }
  .el-button--primary {
    color: #fff;
    background-color: $maintheme;
    border-color: $maintheme;
  }
</style>
